'use client'

import React from 'react';
import Commingsoon from '@/Components/commigsoon';
function awards(params) {
	return (
		<div>
			<Commingsoon/>
		</div>
	);
}
export default awards;